module.exports = __webpack_public_path__ + "0b95e6cc883943b0632c994872684da3.pdf";